<!-- Template do adaptador de componente webhook -->
<!-- ✅ CORREÇÃO: Só renderiza quando formGroup, webhookField e formReady estão prontos -->
<div class="webhook-adapter" 
     *ngIf="formReady && formGroup && webhookField" 
     [formGroup]="formGroup"
     [attr.data-component-id]="node?.id">

  <!-- Mensagem de dependência quando pré-requisito não satisfeito -->
  <div class="dependency-warning" *ngIf="hasDependencies && !dependencyMet">
    <nz-alert
      nzType="warning"
      [nzMessage]="dependencyMessage"
      nzShowIcon
      [nzBanner]="true"
      style="margin-bottom: 4px; font-size: 12px;">
    </nz-alert>
  </div>

  <webhook-common 
    [field]="webhookField" 
    [configuration]="webhookConfig" 
    [mainformGroup]="formGroup"
    [rootForm]="formGroup"
    [variables]="variables"
    (change)="onWebhookChange($event)">
  </webhook-common>
</div>